import React, { Component } from "react";
import Table, { TableColumn } from "./Table";
import SchoolAssignmentsResult from "../models/analytics/SchoolAssignmentsResult";
import { TableRowProps } from "./TableRow";
import { formatFloat, formatPercentage } from "../utils/Utils";

interface TenantAnalyticsListProps {
    items: SchoolAssignmentsResult[];
    startDate: string;
    endDate: string;
    academicYear: number;
}

interface TenantAnalyticsListState {

}

export default class TenantAnalyticsList extends Component<TenantAnalyticsListProps, TenantAnalyticsListState>
{
    private static readonly columns: TableColumn[] = [
        { title: "School", propertyPath: "schoolName", enableSort: true, flex: 2 },
        { title: "Classes with Assignments", propertyPath: "percentageOfClassesWithAssignments", enableSort: true, flex: 1, valueFormatter: formatPercentage },
        { title: "Average assignments per class", propertyPath: "averageAssignmentsPerClass", enableSort: true, flex: 1, valueFormatter: formatFloat },
        { title: "Active Assignments", propertyPath: "activeAssignments", enableSort: true, flex: 1 },
        { title: "Total Assignments", propertyPath: "totalAssignments", enableSort: true, flex: 1 },
    ];

    private readonly rowProps = (item: SchoolAssignmentsResult): TableRowProps => {
        return {
            to: this.getLinkSchoolLink(item),
            enableRowLink: true
        };
    }

    private readonly getLinkSchoolLink = (item: SchoolAssignmentsResult): string => {
        return `/manage/${item.tenantId}/${item.schoolCode}/assignment-analytics-overview?startDate=${this.props.startDate}&endDate=${this.props.endDate}&academicYear=${this.props.academicYear}`;
    }

    public componentDidMount() {
    }

    public render() {
        return (
            <Table
                title={"Schools"}
                items={this.props.items}
                columns={TenantAnalyticsList.columns}
                rowPropsForItem={this.rowProps}
                defaultSortColumnPath={'schoolName'}
                enableSort={true}>
            </Table>
        );
    }
}